import { useEffect, useState } from "react";
import {
  collectionGroup,
  getDocs,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { firestore } from "../firebase";
import { useAuth } from "../contexts/AuthContext";

export default function useBackedCampaigns() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    async function load() {
      if (!user) {
        if (!mounted) return;
        setItems([]);
        setLoading(false);
        return;
      }

      setLoading(true);

      try {
        const pledgesQuery = query(
          collectionGroup(firestore, "pledges"),
          where("userId", "==", user.uid),
          orderBy("createdAt", "desc")
        );

        const snapshot = await getDocs(pledgesQuery);

        const results = snapshot.docs.map((docSnap) => ({
          id: docSnap.id,
          ...docSnap.data(),
        }));

        if (!mounted) return;
        setItems(results);
      } catch (error) {
        console.error("Failed to load backed campaigns:", error);
        if (!mounted) return;
        setItems([]);
      } finally {
        if (!mounted) return;
        setLoading(false);
      }
    }

    load();

    return () => {
      mounted = false;
    };
  }, [user]);

  return {
    items,
    loading,
    totalBacked: items.length,
    latestBacked: items[0] || null,
  };
}